import * as React from 'react';
export const abnamroSvg = React.forwardRef(function abnamroSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#009788',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#F3B229',
          d: 'M16 26.182v-16l8.728 8.727z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'M24.728 5.818v13.091L16 11.636v14.546l-8.727-7.273V5.818z',
        }),
      ),
    ),
  );
});
abnamroSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var abnamro = {
  category: 'brand',
  colorable: false,
  name: 'abnamro',
  svg: abnamroSvg,
};
